
import { Component, Vue } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'

import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacHeaderWithMenue
  }
})
export default class Content extends Vue {
  content = ''

  mounted () {
    this.$store.dispatch('loadRallyRound', this.$route.params.rallyRoundId)
    this.loadContent()
    this.setIframeSize()
    setInterval(this.setIframeSize, 1000)
    this.fixHeaderSize()
  }

  fixHeaderSize () {
    const header = document.getElementsByTagName('header')[0]
    if (!header) {
      return
    }

    (this.$refs.content as HTMLElement).style.marginTop = header.getClientRects()[0].height + 'px'
  }

  setIframeSize () {
    const iframe = document.getElementsByClassName('content-container')[0] as HTMLIFrameElement
    const header = document.getElementsByClassName('header')[0]
    const app = document.getElementById('app')
    if (app && header && iframe) {
      iframe.style.height = (app.getBoundingClientRect().height - header.getBoundingClientRect().height - 10) + 'px'
    }
  }

  async loadContent () {
    this.content = await (await Http.request(`/api/content/${this.$route.params.contentId}`)).text()
  }
}
